import { useTranslation } from 'react-i18next';

import { useHasSocialWallet } from './use-has-social-wallet';

/**
 * Custom hook get i18next translation function (`t`) scoped and use the _social key suffix and fall back to original key if not found.
 */
export const useSocialWalletTranslation = (namespace?: Parameters<typeof useTranslation>[0]) => {
    const { t } = useTranslation(namespace);
    const hasSocialWallet = useHasSocialWallet();

    return (key: string, options?: any) => {
        if (hasSocialWallet) {
            return t([`${key}_social`, key], options);
        }
        return t(key, options);
    };
};
